import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
      </header>
      <main className="App-main">
        <h1>Greetings!</h1>
        <h2>Are you getting attacked by this server? Don't panic, there are a few reasons why this is happening:</h2>

        <div className="content-box">
          <ol>
            <li>We are conducting an authorized Penetration test or Phishing engagement that has been requested by your IT department.</li>
            <li>We are using this host for a bug bounty project, from e.g. H1 or Bugcrowd.</li>
            <li>We accidentally stepped out of scope while doing 1) or 2).</li>
            <li>Security research — recently, payloads were fired against a few thousand domains in order to see what comes back. In any case, there are no evil intentions behind these attacks.</li>
          </ol>
        </div>

        <p className="contact">
          If you think that none of these scenarios apply to your observations, or if you simply want more information, feel free to contact: <a href="mailto:abuse@0x4a.se">abuse@0x4a.se</a>
        </p>

        <a
          className="App-link"
          href="https://0x4a.se"
          target="_blank"
          rel="noopener noreferrer"
        >
          More information can be found at 0x4a.se
        </a>
      </main>
    </div>
  );
}

export default App;
